import React, {useEffect, useState} from 'react';
import {HashRouter as Router, Route, Routes} from 'react-router-dom';
import BaraemDashboard from './BaraemDashboard';
import BaraemQuestionDashboard from './baraemQuestionAnswer/BaraemQuestionDashboard';
import AddChild from './baraemAddChild/AddChild';
import EditChild from './baraemAddChild/EditChild';
import {fetchTranslationData} from "../../services/translation/translation";
import {ServiceTranslation} from "../../utils/constants";
import {configureFirstIframe} from "../../utils/util";

const BaraemServices = () => {
    const [translationMap, setTranslationMap] = useState(null);
    useEffect(() => {
        fetchTranslationData(ServiceTranslation.Baraem).then((result) => {
            setTranslationMap(result);
        });
        configureFirstIframe(1000, 1300, true);
    }, []);
    return (
        <>
            <Router>
                <Routes>
                    <Route path='/' element={<BaraemDashboard translationMap={translationMap}/>}/>
                    <Route path='/baraemQuestion' element={<BaraemQuestionDashboard translationMap={translationMap}/>}/>
                    <Route path='/addChild' element={<AddChild translationMap={translationMap}/>}/>
                    <Route path='/editProfile' element={<EditChild translationMap={translationMap}/>}/>

                </Routes>
            </Router>
        </>
    );
}

export default BaraemServices;
